var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"heading-container"},[(_vm.props.icon)?_c('span',{staticClass:"heading-icon"},[_c('span',{class:['fa', ("fas " + (_vm.props.icon))]})]):_vm._e(),_c('span',{class:['heading-text', _vm.props.size]},[_vm._v(" "+_vm._s(_vm.props.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }